export const patChecklistData = [
  {
    sectionTitle: "1. PAT Verification",
    items: [
      { id: "1_1", label: "1.1", text: "PAT register is available and up to date" },
      { id: "1_2", label: "1.2", text: "All portable electrical appliances have a valid PAT label" },
      { id: "1_3", label: "1.3", text: "Out of date appliances have been removed from use" },
      { id: "1_4", label: "1.4", text: "PAT test certificates are available for inspection" },
      { id: "1_5", label: "1.5", text: "PAT register is complete and accurate" },
      { id: "1_6", label: "1.6", text: "High risk appliances (e.g. fridges) are re-tested as required" },
      { id: "1_7", label: "1.7", text: "Any issues identified have been rectified" }
    ]
  },
  {
    sectionTitle: "2. Manager Verification",
    items: [
      { id: "2_1", label: "2.1", text: "PAT check completed" },
      { id: "2_2", label: "2.2", text: "Review completed and signed" }
    ]
  }
];
